const Personal = () =>
    import ( /* webpackChunkName: "DoctorRegister" */ "@/components/registration/doctor/PersonalDetails");

const Clinic = () =>
    import ( /* webpackChunkName: "DoctorRegister" */ "@/components/registration/doctor/ClinicDetails");

const alliedQualifications = () =>
    import ( /* webpackChunkName: "DoctorRegister" */ "@/components/registration/doctor/alliedQualificationsSpecialities");

const Residential = () =>
    import ( /* webpackChunkName: "DoctorRegister" */ "@/components/registration/doctor/ResidentialDetails");

const AlliedAdditional = () =>
    import ( /* webpackChunkName: "DoctorRegister" */ "@/components/registration/doctor/AlliedAdditionalDetails");

const AlliedAssociation = () =>
    import ( /* webpackChunkName: "DoctorRegister" */ "@/components/registration/doctor/AlliedAssociationDetails");


export default [{
        path: "",
        // name: "register.doctor.root",
        redirect: {
            name: "register.allied.owner"
        }
    },
    {
        path: "personal",
        name: "register.allied.owner",
        component: Personal
    },
    {
        path: "allied_additional",
        name: "register.allied.allied_additional",
        component: AlliedAdditional
    },
    {
        path: "allied_associations",
        name: "register.allied.allied_association",
        component: AlliedAssociation
    },
    {
        path: "clinics",
        name: "register.allied.clinic",
        component: Clinic
    },
    {
        path: "allied_qualifications",
        name: "register.allied.allied_qualifications",
        component: alliedQualifications
    },
    {
        path: "residential",
        name: "register.allied.residential",
        component: Residential
    },
];